var _excluded = ["label", "description", "error", "autocomplete", "className", "format", "value"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import Label from './Label';
export default React.forwardRef(function (_ref, ref) {
  var label = _ref.label,
      description = _ref.description,
      error = _ref.error,
      _ref$autocomplete = _ref.autocomplete,
      autocomplete = _ref$autocomplete === void 0 ? 'on' : _ref$autocomplete,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      format = _ref.format,
      value = _ref.value,
      input = _objectWithoutProperties(_ref, _excluded);

  var errId = error ? "errMessage-".concat(input.name) : null;
  return /*#__PURE__*/React.createElement("div", {
    className: "form-group ".concat(className, " ").concat(error ? 'has-error' : '')
  }, /*#__PURE__*/React.createElement(Label, {
    label: label,
    id: input.id,
    required: input.required
  }), description ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("small", null, description)) : null, /*#__PURE__*/React.createElement("div", {
    className: "cb-input-state"
  }, /*#__PURE__*/React.createElement("input", _extends({}, input, {
    value: format ? format(value) : value,
    type: input.type || 'text',
    className: "form-control",
    autoComplete: autocomplete,
    ref: ref,
    "aria-describedby": errId
  })), error ? /*#__PURE__*/React.createElement("i", {
    className: "cb-glyph cb-x-mark",
    "aria-hidden": true
  }) : null), error ? /*#__PURE__*/React.createElement("p", {
    tabIndex: "-1",
    id: errId,
    className: "cb-error-msg",
    role: "alert"
  }, error) : null);
});